// Configurações do Google Tag Manager
export const GTM_CONFIG = {
  // ID do container do Google Tag Manager
  CONTAINER_ID: process.env.REACT_APP_GTM_CONTAINER_ID || 'GTM-MWH737P9',
  
  // Configurações adicionais
  CONFIG: {
    send_page_view: true,
    anonymize_ip: true, // Para conformidade com GDPR
  }
};

// Função para enviar eventos personalizados para o GTM
export const trackEvent = (eventName, eventCategory, eventLabel, eventValue) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      event_category: eventCategory,
      event_label: eventLabel,
      value: eventValue,
    });
  }
};

// Funções específicas para o restaurante
export const trackMenuView = (menuType) => {
  trackEvent('menu_view', 'engagement', menuType);
};

export const trackReservationClick = () => {
  trackEvent('reservation_click', 'conversion', 'whatsapp');
};

export const trackLanguageChange = (language) => {
  trackEvent('language_change', 'user_interaction', language);
};

export const trackButtonClick = (buttonName, section) => {
  trackEvent('button_click', 'engagement', `${section}_${buttonName}`);
};

export const trackMenuButtonClick = (menuType) => {
  trackEvent('menu_button_click', 'engagement', menuType);
};
